const menuBtn = () => {
    const buttons = document.querySelectorAll('.header-menu__btn');

    buttons.forEach((button) => {
        button.addEventListener('click', function () {
            const parent = this.closest('.menu-item-has-children');
            const isOpen = parent.classList.contains('active');

            document.querySelectorAll('.menu-item-has-children.active')
                .forEach((el) => el.classList.remove('active'));

            if (!isOpen) {
                parent.classList.add('active');
            }
        });
    });

    document.addEventListener('click', (e) => {
        if (!e.target.closest('.menu-item-has-children')) {
            document.querySelectorAll('.menu-item-has-children.active')
                .forEach((el) => el.classList.remove('active'));
        }
    });
};

export default menuBtn;
